module.exports = __webpack_public_path__ + "media/images/emblems/Oberdorf-blason-3f4ea7b7db43c52afebac1b774c58a88.png";